import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addProductService,
  deleteProductService,
  getProductService,
  getProductsService,
  searchProductsService,
  updateProductService,
} from "./products.services";
import {
  ICommonProduct,
  IProduct,
  IProductRequest,
  IProductResponse,
  ISearchProductResponse,
} from "./products.interface";

const getProducts = createAsyncThunk<
  IProductResponse,
  IProductRequest,
  { rejectValue: any }
>("products/getProducts", async (payload, { rejectWithValue }) => {
  try {
    const { page, limit, sort, order, search } = payload ?? {};

    const data = await getProductsService(
      page ?? 0,
      limit ?? 10,
      sort ?? "inserted",
      order ?? "desc",
      search ?? ""
    );

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});

const getProduct = createAsyncThunk<IProduct, string, { rejectValue: any }>(
  "products/getProduct",
  async (id: string, { rejectWithValue }) => {
    try {
      const data = await getProductService(id);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response.data?.message);
    }
  }
);

const addProduct = createAsyncThunk<
  IProduct,
  ICommonProduct,
  { rejectValue: any }
>("products/addProduct", async (payload, { rejectWithValue }) => {
  try {
    const data = await addProductService(payload);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});

const deleteProduct = createAsyncThunk<IProduct, string, { rejectValue: any }>(
  "products/deleteProduct",
  async (id, { rejectWithValue }) => {
    try {
      const data = await deleteProductService(id);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response.data?.message);
    }
  }
);

const updateProduct = createAsyncThunk<
  IProduct,
  { id: string; payload: ICommonProduct },
  { rejectValue: any }
>(
  "products/updateProduct",
  async (
    {
      id,
      payload,
    }: {
      id: string;
      payload: ICommonProduct;
    },
    { rejectWithValue }
  ) => {
    try {
      const data = await updateProductService(id, payload);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response.data?.message);
    }
  }
);

const searchProducts = createAsyncThunk<
  ISearchProductResponse[],
  string,
  { rejectValue: any }
>("products/searchProducts", async (search, { rejectWithValue }) => {
  try {
    const data = await searchProductsService(search);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});

export {
  getProducts,
  getProduct,
  addProduct,
  deleteProduct,
  updateProduct,
  searchProducts,
};
